import React, { useEffect, useRef } from "react";

// Elegant flowing wave-lines (canvas) — smooth animated ribbons, very subtle.
export default function WaveLines({ className = "", color = "20,162,75" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let raf, w, h, t = 0;

    const resize = () => {
      w = canvas.offsetWidth; h = canvas.offsetHeight;
      canvas.width = w * DPR; canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };

    const draw = () => {
      t += 0.006;
      ctx.clearRect(0, 0, w, h);
      const lines = 6;
      for (let l = 0; l < lines; l++) {
        const baseY = h * (0.35 + l * 0.09);
        const amp = 26 + l * 10;
        const alpha = 0.10 + (l / lines) * 0.10;
        ctx.beginPath();
        for (let x = -20; x <= w + 20; x += 12) {
          const y =
            baseY +
            Math.sin(x * 0.004 + t + l * 0.7) * amp +
            Math.cos(x * 0.0016 - t * 0.8 + l) * amp * 0.6;
          if (x === -20) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.strokeStyle = `rgba(${color},${alpha})`;
        ctx.lineWidth = 1.2;
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [color]);

  return <canvas ref={ref} className={`h-full w-full ${className}`} />;
}
